<template>
 <div>
    <b-row>
      <b-col sm="12">
        <b-overlay :show="showOverlay" rounded>
          <b-card>
            <h3 class="chr-h3"> <b-icon icon="globe2"></b-icon> <translate>Bookings</translate></h3>
            <b-col sm="12">
              <b-row>
                <SearchForm
                  :params="model.params"
                  :results="model.results"
                  @search="onSearch"
                />
              </b-row>
            </b-col>
          </b-card>
        </b-overlay>
        <template  v-if="results.length">
          <b-card class="my-3">
            <b-row>
              <b-col sm="4" class="d-flex align-items-center"><h6 class="mb-0"><b>{{results.length}}</b> results</h6> </b-col>
              <b-col sm="4" class="offset-4">
                <select @change="onResultsPerPage($event.target.value)" class="form-control chr-form-control">
                  <option v-for="result in model.resultsPerPage" :key="result.label" :value="result.value" >{{result.label}}</option>
                </select>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <!-- {{results}} -->
            <BookingResults
              :results="model.results"
              @view="onView"
              @editPassenger="editPassenger"/>
          </b-card>
        </template>
      </b-col>
      <b-col>
        <b-card no-body class="p-2 mt-3">
          <b-pagination
            v-model="currentPage"
            :totalRows="model.results.length"
            :per-page="resultsPerPage"
            @change="scrollToTop()"
            align="center"
            class="mt-4"
            />
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="modal" title="Modal Info" size="xl" no-close-on-backdrop hide-header hide-footer>
      <SimpleModalHeader  @closeModal="close" />
      <EditPassenger :bookingId="currentBooking" @closeModal="close" />
    </b-modal>
  </div>
</template>

<script>
import model from './services/model'

import SearchForm from './components/search_form'
import BookingResults from './components/booking_results'
import viewMixin from '../shared/mixins/search_views'
// import SortFields from '../shared/components/sort_fields'
import SimpleModalHeader from '@/app/private/shared/components/simple_modal_header'
import EditPassenger from './components/edit_passenger'

export default {
  name: 'BookingSearch',
  components: { SearchForm, BookingResults, EditPassenger, SimpleModalHeader },
  mixins: [viewMixin],
  data () {
    return {
      model,
      showOverlay: false,
      modal: false,
      currentBooking: null
    }
  },
  computed: {
    results () {
      return model.results
    }
  },
  methods: {
    onSearch (params) {
      this.showOverlay = true
      model.search(params)
        .finally(() => { this.showOverlay = false })
    },
    onView (id) {
      this.$router.push({
        name: 'Private/Bookings/View',
        params: {
          Id: id
        }
      })
    },
    editPassenger (id) {
      this.currentBooking = id
      this.modal = true
    },
    close () {
      this.modal = false
    },
    onResultsPerPage (value) {
      var resultsPerPage = parseInt(value)

      if (resultsPerPage) this.model.selectedResultsPerPage = resultsPerPage
      else this.model.selectedResultsPerPage = this.model.results.length
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
